import React from "react";
import KuikaComponentIcon from "../../../../ui-kit/kuika-component-icon/kuika-component-icon";
import { ShowcaseFrame } from "../_layout/showcase-frame";
import { SpecRow } from "../_layout/spec-row";

const COMPONENT_SAMPLES: string[] = [
  "Row",
  "Col",
  "Label",
  "Button",
  "Icon",
  "Image",
  "Input",
  "Checkbox",
  "Switch",
  "Table",
  "Modal",
  "Tabs",
  "Chart",
  "Map",
  "Calendar",
  "Carousel"
];

export const ComponentIconStory: React.FC = (): JSX.Element => {
  return (
    <ShowcaseFrame
      title="Component Icon"
      componentName="KuikaComponentIcon"
      sourcePath="ui-kit/kuika-component-icon"
      description="Mask-based thumbnail used in the component browser. Hover swaps to a brighter variant of the same icon."
    >
      <SpecRow label="Gallery" caption="hover any tile to see the swap state">
        {COMPONENT_SAMPLES.map((name: string) => (
          <div key={name} className="lab-stack" style={{ alignItems: "center", gap: 6 }}>
            <KuikaComponentIcon name={name} />
            <span className="lab-caption">{name}</span>
          </div>
        ))}
      </SpecRow>
      <SpecRow label="Size variants" caption="width / height — defaults to 40px square">
        {[24, 32, 40, 56].map((size: number) => (
          <div key={size} className="lab-stack" style={{ alignItems: "center", gap: 6 }}>
            <KuikaComponentIcon name="Button" width={size} height={size} />
            <span className="lab-caption">{size}px</span>
          </div>
        ))}
      </SpecRow>
    </ShowcaseFrame>
  );
};
